import React from "react";
import clsx from "clsx";

type Props = {
  fill?: boolean;
  className?: string;
  style?: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
    clipPath?: string;
  };
};

export default function IndicatorStandartRPM({ className, fill, style }: Props) {
  return (
    <div
      className={clsx("flex items-stratch gap-[2px] -skew-x-[10deg]", className)}
      style={{
        maskImage: fill
          ? `linear-gradient(to right, rgba(0,0,0,.2) 0%, black 50%, black 60%)`
          : undefined,
        ...style,
      }}
    >
      <div>
        <div className="flex items-center gap-[1px]">
          {new Array(37).fill(null).map((_, index) => (
            <div
              key={`${index + index}`}
              className={clsx(
                "w-[3px] h-[10px] rounded-[2px]",
                fill ? "bg-[#ffc147]" : "bg-white/30",
              )}
            />
          ))}
        </div>
        <div
          className={clsx(
            "h-[3px] w-full rounded-[2px] mt-[1px]",
            fill ? "bg-[#ffc147]" : "bg-white/30",
          )}
        />
      </div>
      <div className="flex items-center gap-[1px]">
        {new Array(13).fill(null).map((_, index) => (
          <div
            key={`${index + index}`}
            className={clsx(
              "w-[3px] h-full rounded-[2px]",
              fill ? "bg-[#f74b4b]" : "bg-[#f74b4b] opacity-30",
            )}
          />
        ))}
      </div>
    </div>
  );
}
